import { render, staticRenderFns } from "./frgz.vue?vue&type=template&id=1193f84e&scoped=true&"
import script from "./frgz.vue?vue&type=script&lang=js&"
export * from "./frgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1193f84e",
  null
  
)

export default component.exports